document.addEventListener('DOMContentLoaded', function () {
  gsap.registerPlugin(ScrollTrigger);

  let body = document.querySelector('body');
  let header = document.querySelector('header');
  const headerWrapper = document.querySelector('#header-wrapper');
  if (body.classList.contains('index')) {
    function showHeaderOnScroll(event) {
      if (window.scrollY >= 50) {
        headerWrapper.classList.add('!top-0');
        document.removeEventListener('scroll', showHeaderOnScroll);
      }
    }
    document.addEventListener('scroll', showHeaderOnScroll);
    if (window.scrollY >= 50) {
      headerWrapper.classList.add('!top-0');
    }
  }

  let mobileNavTrigger = document.getElementById('mobile-nav-trigger');
  let mobileNav = document.getElementById('mobile-nav');
  let menuIcon = mobileNavTrigger.querySelector('.menu-icon');
  let closeIcon = mobileNavTrigger.querySelector('.close-icon');
  mobileNavTrigger.addEventListener('click', function () {
    if (mobileNav.classList.contains('open')) {
      closeMenu();
    } else {
      closeCartDrawer();
      openMenu();
    }
  });
  function openMenu() {
    gsap.to(mobileNav, {
      autoAlpha: 1,
      onComplete: function () {
        mobileNav.classList.add('open');
      },
    });
    gsap.to(menuIcon, {
      autoAlpha: 0,
    });
    gsap.to(closeIcon, {
      autoAlpha: 1,
    });
  }
  function closeMenu() {
    gsap.to(mobileNav, {
      autoAlpha: 0,
      onComplete: function () {
        mobileNav.classList.remove('open');
      },
    });
    gsap.to(menuIcon, {
      autoAlpha: 1,
    });
    gsap.to(closeIcon, {
      autoAlpha: 0,
    });
  }

  let cartDrawerOpen = document.getElementById('cart-drawer-open');
  let cartDrawerClose = document.getElementById('cart-drawer-close');
  let cartDrawer = document.getElementById('cart-drawer');
  cartDrawerOpen.addEventListener('click', function () {
    closeMenu();
    openCartDrawer();
  });
  cartDrawerClose.addEventListener('click', function () {
    closeCartDrawer();
  });
  document.addEventListener('click', function (e) {
    if (e.target == cartDrawerOpen) {
      return;
    } else if (!e.target.closest('#cart-drawer') && cartDrawer.classList.contains('open')) {
      closeCartDrawer();
    }
  });
  function openCartDrawer() {
    gsap.to(cartDrawer, {
      x: 0,
      autoAlpha: 1,
      onComplete: function () {
        cartDrawer.classList.add('open');
      },
    });
  }
  function closeCartDrawer() {
    gsap.to(cartDrawer, {
      x: '36rem',
      autoAlpha: 0,
      onComplete: function () {
        cartDrawer.classList.remove('open');
      },
    });
  }

  const announcementBar = document.querySelector('.announcement-bar');
  document.addEventListener('scroll', function () {
    const headerBox = header.getBoundingClientRect();
    const headerTop = headerBox.top;
    const announcementBarBox = announcementBar ? announcementBar.getBoundingClientRect() : null;
    if (headerTop > 0) {
      cartDrawer.style.marginTop = `${headerTop}px`;
      mobileNav.style.marginTop = `${headerTop}px`;
    } else {
      if (cartDrawer.style.marginTop != '0px') {
        cartDrawer.style.marginTop = `0px`;
      }
      if (mobileNav.style.marginTop != '0px') {
        mobileNav.style.marginTop = `0px`;
      }
    }
    if (window.scrollY === 0 && announcementBar) {
      cartDrawer.style.marginTop = `${announcementBarBox.height}px`;
      mobileNav.style.marginTop = `${announcementBarBox.height}px`;
    }
    if (!announcementBar) {
      return;
    }
    if (window.scrollY <= announcementBarBox.height) {
      announcementBar.style.marginTop = `-${window.scrollY}px`;
    } else {
      if (announcementBar.style.marginTop != `-${announcementBarBox.height}px`) {
        announcementBar.style.marginTop = `-${announcementBarBox.height}px`;
      }
    }
  });

  if (document.querySelector('#diagram-container')) {
    gsap.fromTo(
      '#diagram-container',
      {
        opacity: 0,
      },
      {
        opacity: 1,
        scrollTrigger: {
          trigger: '#diagram-container',
          start: 'top 75%',
          end: 'top top',
          scrub: true,
        },
      }
    );

    gsap.fromTo(
      '#diagram-container',
      {
        opacity: 1,
      },
      {
        opacity: 0,
        scrollTrigger: {
          trigger: '#diagram-container',
          start: 'bottom bottom',
          end: 'bottom center',
          scrub: true,
        },
      }
    );

    gsap.fromTo(
      '#diagram-1',
      { y: -50 },
      {
        y: 100,
        scrollTrigger: {
          trigger: '#diagram-container',
          start: 'top 100%',
          end: 'bottom bottom',
          scrub: true,
        },
      }
    );
    gsap.fromTo(
      '#diagram-2',
      { y: 0 },
      {
        y: 50,
        scrollTrigger: {
          trigger: '#diagram-container',
          start: 'top 100%',
          end: 'bottom bottom',
          scrub: true,
        },
      }
    );
    gsap.fromTo(
      '#diagram-3',
      {
        y: 100,
      },
      {
        y: 0,
        scrollTrigger: {
          trigger: '#diagram-container',
          start: 'top 100%',
          end: 'bottom bottom',
          scrub: true,
        },
      }
    );
  }

  let accordions = document.querySelectorAll('.accordion');

  accordions.forEach(function (accordion) {
    let header = accordion.querySelector('.accordion-header');
    let content = accordion.querySelector('.accordion-content');
    let icon = accordion.querySelector('.accordion-icon');

    header.addEventListener('click', function () {
      if (content.classList.contains('open')) {
        header.classList.remove('open');
        content.classList.remove('open', 'grid-rows-[1fr]');
        content.classList.add('grid-rows-[0fr]');
        icon.classList.remove('rotate-180');
      } else {
        header.classList.add('open');
        content.classList.add('open', 'grid-rows-[1fr]');
        content.classList.remove('grid-rows-[0fr]');
        icon.classList.add('rotate-180');
      }
    });
  });

  const autoSwiperConfig = {
    slidesPerView: 'auto',
    freeMode: true,
    spaceBetween: 16,
    navigation: {
      nextEl: '.nav-next',
      prevEl: '.nav-prev',
    },
    scrollbar: {
      el: '.swiper-scrollbar',
      draggable: 'true',
    },
    breakpoints: {
      640: {
        spaceBetween: 24,
      },
    },
    mousewheel: {
      enabled: true,
      forceToAxis: true,
    },
  };
  const autoSwiper = new Swiper('.auto-swiper', autoSwiperConfig);

  const singleSwiper = new Swiper('.single-swiper', {
    slidesPerView: 1,
    scrollbar: {
      el: '.swiper-scrollbar',
    },
    navigation: {
      prevEl: '.nav-prev',
      nextEl: '.nav-next',
    },
    mousewheel: {
      enabled: true,
      forceToAxis: true,
    },
  });

  // Handle dropdown toggle functionality
  const dropdownHeaders = document.querySelectorAll('.dropdown-header');

  // Click outside handler
  function handleClickOutside(event) {
    const activeDropdowns = document.querySelectorAll('.dropdown.active');

    activeDropdowns.forEach((dropdown) => {
      const content = dropdown.querySelector('.dropdown-content');
      const icon = dropdown.querySelector('img');

      // Check if click is outside the dropdown
      if (!dropdown.contains(event.target)) {
        dropdown.classList.remove('active');
        gsap.to(content, { height: 0 });
        if (icon) icon.classList.remove('rotate-180');
      }
    });
  }

  dropdownHeaders.forEach((header) => {
    header.addEventListener('click', function (e) {
      e.stopPropagation(); // Prevent triggering the outside click immediately

      const dropdown = this.closest('.dropdown');
      const isActive = dropdown.classList.contains('active');
      const content = dropdown.querySelector('.dropdown-content');
      const icon = dropdown.querySelector('img');

      // Close all other open dropdowns first
      document.querySelectorAll('.dropdown.active').forEach((openDropdown) => {
        if (openDropdown !== dropdown) {
          openDropdown.classList.remove('active');
          const openContent = openDropdown.querySelector('.dropdown-content');
          const openIcon = openDropdown.querySelector('img');
          gsap.to(openContent, { height: 0 });
          if (openIcon) openIcon.classList.remove('rotate-180');
        }
      });

      // Toggle current dropdown
      if (isActive) {
        dropdown.classList.remove('active');
        gsap.to(content, { height: 0 });
        if (icon) icon.classList.remove('rotate-180');
      } else {
        dropdown.classList.add('active');
        gsap.to(content, { height: 'auto' });
        if (icon) icon.classList.add('rotate-180');
      }
    });
  });

  // Add click listener to document
  document.addEventListener('click', handleClickOutside);

  // Handle checkbox counting for filter-dropdown elements
  const filterDropdowns = document.querySelectorAll('.filter-dropdown');

  filterDropdowns.forEach((dropdown) => {
    const counter = dropdown.querySelector('.counter');
    if (!counter) return;

    const checkboxes = dropdown.querySelectorAll('input[type="checkbox"]');

    // Update counter initially
    updateCounter();

    // Add event listeners to all checkboxes
    checkboxes.forEach((checkbox) => {
      checkbox.addEventListener('change', updateCounter);
    });

    function updateCounter() {
      const checkedCount = Array.from(checkboxes).filter((cb) => cb.checked).length;
      counter.textContent = checkedCount;
    }
  });

  // Article content image width fix
  const richTextMetafields = document.querySelectorAll('.article-content');
  richTextMetafields.forEach((metafield) => {
    handleSingleImages(metafield);
    handleImageSliders(metafield);
    handleVideos(metafield);
    handleIframes(metafield);
  });

  function handleSingleImages(metafield) {
    const imageElements = metafield.querySelectorAll('p>img');
    if (!imageElements.length) return;
    imageElements.forEach((element) => {
      // remove parent paragraph element max width
      element.parentElement.style.maxWidth = 'unset';
    });
  }

  function handleImageSliders(metafield) {
    // get boilerplate slider component
    const boilerplateSlider = metafield.querySelector('[data-boilerplate="slider"]');
    if (!boilerplateSlider) return;
    const tableElements = metafield.querySelectorAll('table');
    if (!tableElements.length) {
      metafield.removeChild(boilerplateSlider);
      return;
    }
    const maxTableCells = 1;
    tableElements.forEach((table) => {
      // slider tables should only contain one cell
      const tableCellElements = table.querySelectorAll('td');
      if (!tableCellElements.length || tableCellElements.length > maxTableCells) {
        return;
      }
      // hide original table element
      table.classList.add('hidden');
      const imageElements = table.querySelectorAll('td>img');
      if (!imageElements.length) return;
      // clone a new slider component
      const sliderClone = boilerplateSlider.cloneNode(true);
      const sliderComponent = sliderClone.querySelector('[data-slider_component]');
      const sliderWrapper = sliderClone.querySelector('[data-slider_wrapper]');
      imageElements.forEach((image) => {
        // create the slide element, then remove image element from the original table and add it to the cloned slider
        const slide = document.createElement('div');
        slide.classList.add('swiper-slide', '!w-auto');
        slide.appendChild(image);
        sliderWrapper.appendChild(slide);
        image.classList.add('h-[20rem]', 'sm:h-[40rem]');
      });
      // initialize slider and add it to the DOM
      //sliderWrapper.style.maxHeight = '640px';
      sliderClone.removeAttribute('data-boilerplate');
      table.parentElement.insertBefore(sliderClone, table);
      table.parentElement.removeChild(table);
      sliderClone.classList.remove('hidden');
      const sliderSwiper = new Swiper(sliderComponent, autoSwiperConfig);
    });
    // remove boilerplate slider component
    metafield.removeChild(boilerplateSlider);
  }

  function handleVideos(metafield) {
    // get boilerplate video component
    const boilerplateVideo = metafield.querySelector('[data-boilerplate="video"]');
    if (!boilerplateVideo) return;
    const linkElements = metafield.querySelectorAll('p>a[title="video"]');
    if (!linkElements.length) {
      metafield.removeChild(boilerplateVideo);
      return;
    }
    linkElements.forEach((link) => {
      // hide original link element
      link.parentElement.classList.add('hidden');
      // clone a new video component
      const videoClone = boilerplateVideo.cloneNode(true);
      // create the video source element, then set the reference from the original link
      const source = document.createElement('source');
      source.type = 'video/mp4';
      source.src = link.href;
      videoClone.appendChild(source);
      // add video to the DOM
      videoClone.removeAttribute('data-boilerplate');
      link.parentElement.parentElement.insertBefore(videoClone, link.parentElement);
      link.parentElement.parentElement.removeChild(link.parentElement);
      videoClone.classList.remove('hidden');
    });
    // remove boilerplate slider component
    metafield.removeChild(boilerplateVideo);
  }

  function handleIframes(metafield) {
    const iframeElements = metafield.querySelectorAll('p>iframe');
    if (!iframeElements.length) return;
    iframeElements.forEach((element) => {
      // remove parent paragraph element max width
      element.parentElement.style.maxWidth = 'unset';
      // add custom dimensions and styles
      element.height = 'auto';
      element.width = '100%';
      element.classList.add('aspect-video');
    });
  }

  // Select all mega menu toggle elements
  let megaMenuToggles = document.querySelectorAll('.mega-menu-toggle');

  /**
   * Closes all currently open mega menus
   * Removes active classes and animates the closing with GSAP
   */
  function closeAllMegaMenus() {
    // Find currently active toggle and menu
    let activeMegaMenuToggle = document.querySelector('.mega-menu-toggle.active');
    let activeMegaMenu = document.querySelector('.mega-menu.active');

    if (activeMegaMenu && activeMegaMenuToggle) {
      // Remove underline style from toggle
      activeMegaMenuToggle.classList.remove('underline');

      // Animate the closing with GSAP
      gsap.to(activeMegaMenu, {
        autoAlpha: 0, // Animates both opacity and visibility
        onStart: function () {
          // Remove active classes at start of animation
          activeMegaMenu.classList.remove('active');
          activeMegaMenuToggle.classList.remove('active');
        },
        onComplete: function () {
          // Ensure menu is hidden after animation completes
          activeMegaMenu.style.visibility = 'hidden';
        },
      });
    }
  }

  /**
   * Handles clicks outside the header to close mega menus
   * @param {Event} event - The click event
   */
  function handleClickOutsideHeader(event) {
    const header = document.querySelector('header');
    // Check if click is outside header and no animation is running
    if (!header.contains(event.target)) {
      closeAllMegaMenus();
      // Remove this event listener after closing menus
      document.removeEventListener('click', handleClickOutsideHeader);
    }
  }

  // Add click event listeners to all mega menu toggles
  megaMenuToggles.forEach(function (megaMenuToggle) {
    const megaMenu = megaMenuToggle.nextElementSibling;
    if (!megaMenu) return;
    const closeMegaMenu = megaMenu.querySelector('#close-mega-menu');
    let isAnimating; // Flag to track animation state
    megaMenuToggle.addEventListener('click', function (e) {
      if (megaMenuToggle.classList.contains('active')) {
        return;
      }
      e.preventDefault();
      // Prevent this click from bubbling up to document
      e.stopPropagation();

      // If animation is in progress, do nothing
      if (isAnimating) {
        return;
      }
      // If menu is not currently active
      // Find any currently active menu and toggle
      let activeMegaMenuToggle = document.querySelector('.mega-menu-toggle.active');
      let activeMegaMenu = document.querySelector('.mega-menu.active');

      // If there's an active menu, switch to the new one without animation
      if (activeMegaMenu && activeMegaMenuToggle) {
        // Hide current active menu
        activeMegaMenu.style.visibility = 'hidden';
        activeMegaMenu.style.opacity = 0;
        activeMegaMenu.classList.remove('active');
        activeMegaMenuToggle.classList.remove('active', 'underline');

        // Show new menu
        megaMenu.style.visibility = 'inherit';
        megaMenu.style.opacity = 1;
        megaMenu.classList.add('active');
        megaMenuToggle.classList.add('active', 'underline');
      }
      // If no active menu, animate the opening
      else {
        // Add underline style immediately
        megaMenuToggle.classList.add('underline');

        // Animate menu appearance with GSAP
        gsap.to(megaMenu, {
          autoAlpha: 1, // Animates both opacity and visibility
          onStart: function () {
            isAnimating = true;
            // Add active classes at start of animation
            megaMenu.classList.add('active');
            megaMenuToggle.classList.add('active');
          },
          onComplete: function () {
            isAnimating = false;
          },
        });
      }
      // Add document click listener to handle clicks outside header
      document.addEventListener('click', handleClickOutsideHeader);
    });
    if (!closeMegaMenu) return;
    closeMegaMenu.addEventListener('click', function (event) {
      if (!megaMenuToggle.classList.contains('active')) {
        event.preventDefault();
        return;
      }
      // Remove underline style immediately
      megaMenuToggle.classList.remove('underline');

      // Animate menu disappearance with GSAP
      gsap.to(megaMenu, {
        autoAlpha: 0,
        onStart: function () {
          isAnimating = true;
          // Remove active classes at start of animation
          megaMenu.classList.remove('active');
          megaMenuToggle.classList.remove('active');
        },
        onComplete: function () {
          isAnimating = false;
          // Remove the outside click listener when closing via toggle
          document.removeEventListener('click', handleClickOutsideHeader);
        },
      });
    });
  });

  // Store locator Map
  const mapboxMap = document.querySelector("#mapbox-map");
	if (mapboxMap) {
    const locatorData = getLocatorData(mapboxMap);
    const markerImages = [];
    const { api_key, center_coords, zoom_level } = mapboxMap.dataset;
    const [centerLat, centerLng] = center_coords.split("|");
    // add marker thumbnails as images to the map to be rendered as marker symbols
		locatorData.markers.forEach((marker) => {
      locatorData.imageSources[`marker-${marker.properties.id}`] = marker.properties.thumbnail;
			markerImages.push(`marker-${marker.properties.id}`);
		});
		const mapeo = new Mapeo({
			mapboxToken: api_key,
			containerId: "mapbox-map",
			dataSet: locatorData.markers,
			imageSources: locatorData.imageSources,
			markerVariants: [
				{
					iconImageId: "marker-default",
					textColor: "#ffffff",
				}
			],
			markerImages: markerImages,
      initialState: {
        centerCoords: [centerLng, centerLat],
        zoomLevel: parseInt(zoom_level),
			  styleUrl: "mapbox://styles/mapbox/light-v11",
      }
		});
		// use the instance once it is ready
		mapeo.load((thisMapeo) => {
			console.log(thisMapeo);
			// resize event handler to resize map when viewport width changes
      let debounceTimeout;
      window.addEventListener("resize", function (event) {
        clearTimeout(debounceTimeout);
        debounceTimeout = setTimeout(function() {
          thisMapeo.map.resize();
        }, 500);
      });
		});
	}

  function getLocatorData(mapContainer) {
    const markerList = mapContainer.querySelector("[data-markers]");
    const imageSourceList = mapContainer.querySelector("[data-image-sources]");
    if (!markerList) {
      return;
    }

    const markers = markerList.querySelectorAll("[data-marker]");
    if (!markers || !markers.length) {
      return;
    }

    const locatorData = {
      markers: [],
      imageSources: {}
    };

    // add default image sources first
    if (imageSourceList) {
      const imageSources = imageSourceList.querySelectorAll("[data-image-source]");
      if (imageSources && imageSources.length) {
        imageSources.forEach(image => {
          const { imageSource, id } = image.dataset;
          if (!id || !imageSource) return;
          locatorData.imageSources[id] = imageSource;
        });
      }
    }
    // compose markers data
    markers.forEach(marker => {
      const { coords, index, title, address, url, thumbnail } = marker.dataset;
      if (!coords) return;
      const [lat, lng] = coords.split("|");
      const point = {
        coordinates: [lng, lat],
        properties: {
          id: marker.dataset.marker,
          title: title,
          address: address,
          index: index,
          url: url,
          thumbnail: thumbnail ?? false
        }
      };
      locatorData.markers.push(point);
    });

    // remove elements from markup
    mapContainer.removeChild(imageSourceList);
    mapContainer.removeChild(markerList);

    return locatorData;
  }
});
